import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI3S_DEMO_4 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `<span style="color: #BEE3FF;">All reports from AI3S scans are compiled \ninto a centralized data screen.</span> From here,\n Danu gains decision-making power, with\n options to assess, adjust, and reinforce\n security measures for Globe Connect.`,
  subtitle: "Infosys AI3S DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(310),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(308),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_06.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "RESPONSIBLE_AI/AI3S_demo_4_computer.png",
          imageStyle: {
            position: "absolute",
            right: "65px",
            bottom: "68px",
          },
          effect: "animate-opacity",
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_4_lock.png",
          imageStyle: {
            position: "absolute",
            right: "325.54px",
            bottom: "504.67px",
          },
          effect: "animate-opacity",
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_4_light.png",
          imageStyle: {
            position: "absolute",
            right: "648px",
            bottom: "68px",
          },
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_4_fire.png",
          imageStyle: {
            position: "absolute",
            right: "94px",
            bottom: "86px",
          },
        },
      ]}
      pageNumber={309}
    />
  ),
};
